module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', [_vm._v("\n    Made with VueJS, Vuex and "), _c('span', {
    staticClass: "hearth"
  }, [_vm._v("❤")]), _vm._v(" by Julien Usson"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("Thanks to "), _c('a', {
    attrs: {
      "href": "http://www.heropatterns.com/"
    }
  }, [_vm._v("Hero Patterns")]), _vm._v(" for this gorgeous hero background")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c79f1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 288
// module chunks = 1